export default __webpack_public_path__ + "static/media/pricing2.e4600eed.png";